import { createRoot } from 'react-dom/client';

import './index.css';
import { AppContainer } from './AppContainer';

// Clear persisted theme to ensure light mode on every application load
localStorage.removeItem('theme');

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root container missing in index.html');
const root = createRoot(rootElement);
// StrictMode disabled — Bryntum Scheduler uses global registries
// that conflict with double-rendering, and the double-mount causes
// every API call to fire twice in development.
root.render(
  <AppContainer />,
);
